import translatorMixin from "./translatorMixin";
import toastMixin from "./toastMixin";
import HttpError from "../Api/Utils/HttpError";

const { translate } = translatorMixin.methods;
const { errorToast } = toastMixin.methods;

const TIMEOUT = 3000;

export function handlePlainError(err) {
    errorToast(err.message, TIMEOUT);
}

/**
 * See errorHandlerMixin to keep error handling logic consistent.
 */
export function handleError(err: HttpError) {
    console.error(err);

    //Source: UserProfileCompletionGuardingEventSubscriber::profileCompletionRequiredResponse
    if (err.statusCode === 428 && err.body?.redirectUrl) {
        window.location.href = err.body.redirectUrl;
        return;
    }

    let message: string;
    if (err.alreadyTranslated) {
        message = err.message;
    } else if (err.statusCode === 403) {
        message = translate(err.message) ?? translate("error.forbidden");
    } else if (err.statusCode === 429) {
        message = translate("error.too_many_requests");
    } else {
        message = translate(err.message) || translate("error.default");
    }

    errorToast(message, TIMEOUT);
}
